module.exports = __webpack_public_path__ + "static/media/introVid.fa7b1676.png";